// Ajuste ordem imports conforme regra import/order
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Importa validação de ambiente
import { env, requireEnv } from '@/config/env';

// Imports internos
import App from './App';
import './styles/index.css';

// Inicializa Sentry somente se houver DSN configurado (obrigatório em produção)
const isProd = import.meta.env.PROD;
const dsn = isProd ? requireEnv('VITE_SENTRY_DSN') : env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: isProd ? 0.2 : 1.0,
    replaysSessionSampleRate: isProd ? 0.05 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    debug: !isProd,
    enableLogs: isProd,
  });
} else {
  console.warn('[Sentry] DSN não definido. Telemetria desativada.');
}

const container = document.getElementById('root');

if (container instanceof HTMLElement) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }: { error: unknown; resetError: () => void }) => {
          const message = error instanceof Error ? error.message : 'Erro desconhecido';
          const stack = error instanceof Error && error.stack ? error.stack : undefined;
          return (
            <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
              <h2>Ocorreu um erro inesperado.</h2>
              <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: 12 }}>
                {message}
              </pre>
              {!isProd && stack && (
                <details style={{ marginTop: 12 }}>
                  <summary>Stack trace</summary>
                  <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: 12 }}>
                    {stack}
                  </pre>
                </details>
              )}
              <button onClick={resetError} aria-label="Tentar novamente">
                Tentar novamente
              </button>
            </div>
          );
        }}
      >
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>
  );
} else {
  Sentry.captureMessage('Elemento root não encontrado no DOM.');
  console.error('Elemento root não encontrado no DOM.');
}
